import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera } from '@fortawesome/sharp-regular-svg-icons'
import { ActionIcon } from '@mantine/core'

import { useScreenshot } from '../../hooks/useScreenshot'

export const SCREENSHOT_SUPPORT_ENABLED = 'SCREENSHOT_SUPPORT_ENABLED'
type TestIdScreenshotButtonProps = {
  targetTestId: string
  filename?: string
}

export const TestIdScreenshotButton = ({
  targetTestId,
  filename,
}: TestIdScreenshotButtonProps): React.ReactElement => {
  const { takeScreenshot } = useScreenshot({
    dataTestId: targetTestId,
    filename,
  })

  return (
    <ActionIcon onClick={takeScreenshot}>
      <FontAwesomeIcon icon={faCamera} />
    </ActionIcon>
  )
}
